export default __webpack_public_path__ + "img/favicons/favicon-16x16.png";